module.exports = __webpack_public_path__ + "img/TH.90f009a2.svg";